import { Box, Flex, Grid, GridItem, Text, useToast } from '@chakra-ui/react'
import * as S from '../styles'
import { FiUpload } from 'react-icons/fi'
import { motion } from 'framer-motion'
import { useState } from 'react'

import { api } from '../../../../services/api'
import { useQueryClient } from 'react-query'
import { ModalBaseIlustracoes } from '../ModalBaseIlustracoes'
export function CardItem({ item, index, onSubmit, baseLayout, isIlustracao }) {
  const [corelName, setCorelName] = useState({})
  const [showImage, setShowImage] = useState(false)
  const [loadingCorel, setLoadingCorel] = useState(false)
  const [loadingIlustracao, setLoadingIlustracao] = useState(false)
  const [ilustracaoName, setIlustracaoName] = useState('')
  const queryClient = useQueryClient()
  const toast = useToast()

  async function uploadCorel(e, itemId) {
    if (e.target.files[0].type !== 'application/pdf') {
      toast({
        title: 'Erro',
        description: 'O arquivo deve ser um PDF',
        status: 'error',
        duration: 13000,
        isClosable: true,
        position: 'top-right',
      })
      return
    }

    let arquivo = e.target.files[0]

    try {
      setLoadingCorel(true)

      const formData = new FormData()

      formData.append('file', arquivo)
      formData.append('numero_nota', item.numero_nota)
      formData.append('sequencia', item.sequencia)
      formData.append('codigo_produto', item.codigo_produto)
      formData.append('id', item.id)

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      const response = await api.post('/site/v2/fluxo-layout/upload-pdf-layout', formData, config)

      if (response.status === 400) {
        toast({
          title: 'Erro',
          description: 'Erro ao enviar o arquivo',
          status: 'error',
          duration: 13000,
          isClosable: true,
          position: 'top-right',
        })
      }

      toast({
        title: 'Sucesso',
        description: 'Arquivo enviado com sucesso',
        status: 'success',
        duration: 13000,
        isClosable: true,
        position: 'top-right',
      })

      setCorelName((prevCorelName) => ({
        ...prevCorelName,
        [item.id]: arquivo?.name,
      }))
      setLoadingCorel(false)

      queryClient.invalidateQueries('info-solicitacao-layout')

      // onClose()

      onSubmit({
        numero_nota: item.numero_nota,
      })
    } catch (error) {
      console.log(error)
      setLoadingCorel(false)
    }
  }

  async function uploadIlustracao(e, itemId) {
    if (e.target.files[0].type !== 'application/pdf') {
      toast({
        title: 'Erro',
        description: 'O arquivo deve ser um PDF',
        status: 'error',
        duration: 13000,
        isClosable: true,
        position: 'top-right',
      })
      return
    }

    let arquivo = e.target.files[0]

    try {
      setLoadingIlustracao(true)

      const formData = new FormData()

      formData.append('file', arquivo)
      formData.append('numero_nota', item.numero_nota)
      formData.append('sequencia', item.sequencia)
      formData.append('codigo_produto', item.codigo_produto)
      formData.append('id', item.id)

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      const response = await api.post('/site/v2/fluxo-layout/upload-arquivo-pdf-fechamento', formData, config)

      if (response.status === 400) {
        toast({
          title: 'Erro',
          description: 'Erro ao enviar o arquivo',
          status: 'error',
          duration: 13000,
          isClosable: true,
          position: 'top-right',
        })
      }

      if (response.status === 200) {
        toast({
          title: 'Sucesso',
          description: 'Arquivo enviado com sucesso',
          status: 'success',
          duration: 13000,
          isClosable: true,
          position: 'top-right',
        })
      }

      setIlustracaoName(arquivo?.name)
      setLoadingIlustracao(false)

      queryClient.invalidateQueries('info-solicitacao-layout')

      // onClose()

      onSubmit({
        numero_nota: item.numero_nota,
      })
    } catch (error) {
      console.log(error)
      setLoadingIlustracao(false)
    }
  }

  function firstLetterUpperCaseRestLowerCaseAndTreeDotsLength(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase().substring(0, 15) + '...'
  }

  return (
    <Box position={'relative'}>
      <motion.div
        ey={item.id}
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{
          ease: 'linear',
          duration: 2,
          delay: index * 0.1,
          x: { duration: 1 },
        }}
      >
        <Grid
          gridTemplateColumns={isIlustracao ? '.7fr 1fr 1fr 1fr' : '.7fr 1fr 1fr'}
          gap={4}
          alignItems={'center'}
          justifyContent={'space-between'}
          paddingBlock={2}
          paddingInline={4}
          borderRadius={'md'}
          border={'1px solid'}
          borderColor={'gray.200'}
          _hover={{
            borderColor: 'gray.300',
            transform: 'scale(1.01)',
            cursor: 'pointer',
          }}
          onMouseEnter={() => setShowImage(true)}
          onMouseLeave={() => setShowImage(false)}
          position="relative"
        >
          <Text as={'span'} fontSize={'.9rem'} fontWeight={'bold'}>
            Cod.: {item.codigo_produto}
          </Text>
          <Text as={'span'} fontSize={'.9rem'} fontWeight={'500'} color={'gray.500'}>
            {firstLetterUpperCaseRestLowerCaseAndTreeDotsLength(item.nome_produto)}
          </Text>

          {isIlustracao && (
            <>
              <S.Inputas
                type="file"
                id={`ilustracao-${item.id}`}
                name="file"
                onChange={(e) => {
                  uploadIlustracao(e, item.id)
                }}
              />

              <S.Label htmlFor={`ilustracao-${item.id}`}>
                {' '}
                <S.Textas>
                  {loadingIlustracao
                    ? 'Carregando...'
                    : ilustracaoName[item.id]
                      ? firstLetterUpperCaseRestLowerCaseAndTreeDotsLength(ilustracaoName[item.id])
                      : 'PDF - Fechamento'}
                </S.Textas>
                <FiUpload />
              </S.Label>
            </>
          )}

          <S.Inputas
            type="file"
            id={`corel-${item.id}`}
            name="file"
            onChange={(e) => {
              uploadCorel(e, item.id)
            }}
            //só deixa pdf
            accept="application/pdf"
          />
          <S.Label htmlFor={`corel-${item.id}`}>
            {' '}
            <S.Textas>
              {loadingCorel
                ? 'Carregando...'
                : corelName[item.id]
                  ? firstLetterUpperCaseRestLowerCaseAndTreeDotsLength(corelName[item.id])
                  : 'Selecione o layout'}
            </S.Textas>
            <FiUpload />
          </S.Label>

          {isIlustracao && (
            <GridItem colSpan="2">
              <ModalBaseIlustracoes item={item} baseIlustracoes={baseLayout} />
            </GridItem>
          )}

          {showImage && (
            <Flex
              position={'absolute'}
              top={'50%'}
              right={'-15rem'}
              transform={'translateY(-50%)'}
              borderRadius={'md'}
              border={'1px solid'}
              borderColor={'gray.200'}
              padding={2}
              _after={{
                content: '""',
                position: 'absolute',
                top: '50%',
                left: '-1.5rem',
                transform: 'translateY(-50%) rotate(90deg)',
                width: 0,
                height: 0,
                borderLeft: '1rem solid transparent',
                borderRight: '1rem solid transparent',
                borderTop: `1rem solid #cecece`,
              }}
            >
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
                <motion.img
                  src={item.imagem_produto}
                  alt={item.nome_produto}
                  width={200}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.3 }}
                />
              </motion.div>
            </Flex>
          )}
        </Grid>
      </motion.div>
    </Box>
  )
}
